<template>
    <div>
        <upload-media :event-id="value.id"></upload-media>
        <hr />
        <table class="table table-borderless table-responsive">
            <tr v-for="event_media in value.all_media">
                <td class="col-auto">
                    <b>{{ event_media.media.file_name }}</b>
                </td>
                <td class="col-auto">
                    <input class="form-control" type="text" :value="event_media.key" readonly/>
                </td>
                <td>
                    <button @click.prevent="deleteMedia(event_media.media.id)" class="btn btn-danger">
                        <i :class="{
                            fas: true,
                            'fa-times': deletingMediaId !== event_media.media.id,
                            'fa-circle-notch': deletingMediaId === event_media.media.id,
                            'fa-spin': deletingMediaId === event_media.media.id
                        }"></i>
                    </button>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import gql from "graphql-tag";
import UploadMedia from "./UploadMedia";

export default {
    name: "MediaTab",
    components: {UploadMedia},
    data() {
        return {
            deletingMediaId: null,
        }
    },
    props: {
        value: Object
    },
    methods: {
        deleteMedia(mediaId) {
            this.deletingMediaId = mediaId

            this.$apollo.mutate({
                mutation: gql`mutation ($eventId: ID!, $mediaId: ID!) {
                        deleteMediaFromEvent(eventId: $eventId, mediaId: $mediaId)
                    }`,
                variables: {
                    eventId: this.value.id,
                    mediaId: mediaId
                },
                refetchQueries: [
                    'GetEvent'
                ]
            }).then((data) => {
                this.$bvToast.toast('Media eliminato con successo', {
                    title: 'Media eliminato',
                    variant: 'success',
                    solid: true,
                    autoHideDelay: 2
                })
                this.deletingMediaId = null;
            }).catch((error) => {
                this.deletingMediaId = null;
                console.log(error)
            })
        }
    }
}
</script>

<style scoped>

</style>
